import { render, staticRenderFns } from "./staffEdit.vue?vue&type=template&id=2fbba444&scoped=true"
import script from "./staffEdit.vue?vue&type=script&lang=js"
export * from "./staffEdit.vue?vue&type=script&lang=js"
import style0 from "./staffEdit.vue?vue&type=style&index=0&id=2fbba444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbba444",
  null
  
)

export default component.exports